import type { ShopifyOfferDto } from '../offer.types';

/** Placeholders legados que nunca devem vencer o favicon default da plataforma. */
function isUnusableFaviconUrl(url: string): boolean {
  const lower = url.toLowerCase();
  return (
    lower.includes('acme.com')
    || lower.includes('example.com')
    || lower.includes('placeholder')
  );
}

/** Resolve URL de asset do tema: absoluto, path `/api/...`, ou fallback do backend. */
export function resolveCheckoutAssetUrl(url: string | null | undefined, fallbackPath?: string): string | undefined {
  const backendBase = String(import.meta.env.VITE_BACKEND_URL || '').replace(/\/$/, '');
  const origin = backendBase.replace(/\/api$/, '');

  const trimmed = url?.trim();
  const pick = (trimmed && !isUnusableFaviconUrl(trimmed) ? trimmed : undefined) || fallbackPath;
  if (!pick) return undefined;
  if (pick.startsWith('http://') || pick.startsWith('https://')) return pick;
  if (pick.startsWith('/api/')) return `${origin}${pick}`;
  if (pick.startsWith('/')) return `${backendBase}${pick}`;
  return `${backendBase}/${pick}`;
}

/** CPF na etapa de identificação = inverso de `requireCpfOnlyAtPayment` do tema publicado. */
export function cpfOnIdentificationFromTheme(shopifyOffer: ShopifyOfferDto | null | undefined): boolean {
  const flag = shopifyOffer?.checkoutTheme?.checkout?.config?.steps?.identification?.requireCpfOnlyAtPayment;
  if (typeof flag === 'boolean') return !flag;
  // Fallback legado: store.cpfOnIdentification (antes do tema publicado).
  return Boolean(shopifyOffer?.store?.cpfOnIdentification);
}

/** Data de nascimento só se o tema publicado pedir (`steps.identification.requestBirthDate`). */
export function requestBirthDateFromTheme(shopifyOffer: ShopifyOfferDto | null | undefined): boolean {
  return Boolean(shopifyOffer?.checkoutTheme?.checkout?.config?.steps?.identification?.requestBirthDate);
}

export const DEFAULT_CHECKOUT_FAVICON_API_PATH = '/api/assets/defaults/favicon.webp';
